import React from 'react';
import InlineFeedbackBase from './InlineFeedbackBase';

import TInlineFeedback from './types/TInlineFeedback';
import { FeedbackSignals } from '../../types/TEFeedbackSignal';

const Error = ({ children, ...rest }: TInlineFeedback) => (
  <InlineFeedbackBase {...rest} signal={FeedbackSignals.Error}>
    {children}
  </InlineFeedbackBase>
);

export default Error;
